module.exports = __webpack_public_path__ + "static/media/LICENSE.1b45b30f.bin";


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-icons/LICENSE
// module id = 2561
// module chunks = 0